// extracted by mini-css-extract-plugin
module.exports = {"token_button":"style_token_button__1PTrH","token_button_disable":"style_token_button_disable__PlwZt"};